import React from 'react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { MDXProvider } from '@theme-ui/mdx'
import components from '@components/Mdx'

export const PostBody = ({ body }) => {
  return (
    <MDXProvider components={components}>
      {/* todo: why is body null?? */}
      { body && <MDXRenderer>{body}</MDXRenderer> }
    </MDXProvider>
  )
}
